exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sso{background-color:#eff0f1;display:flex;align-items:center;justify-content:center}.sso .tips-info{text-align:center}.epay,.epay .epay-main{height:100%}.axf-container::-webkit-scrollbar,.b-tabs::-webkit-scrollbar{display:none!important}", ""]);

// exports
